export const RoleTypesList = [
{id:"ISORGANIZATION", value: 'BUYER', label: 'Acheteur (Commandé par)'},
{id:"ISORGANIZATION", value: 'INTERMEDIARY_BANK', label: 'Banque intermédiaire'},
{id:"ISORGANIZATION", value: 'CONSIGNEE', label: 'Consignataire'},
{id:"ISORGANIZATION", value: 'AGRICULTURAL_COOPERATIVE'  , label: 'Coopérative agricole'},
{id:"ISORGANIZATION", value: 'RETAILER', label: 'Détaillant'},
{id:"ISORGANIZATION", value: 'DISTRIBUTOR', label: 'Distributeur'},
{id:"ISORGANIZATION", value: 'CUSTOMS', label: 'Douanes'},
{id:"ISORGANIZATION", value: 'E_TAILER', label: 'E-Commerçant'},
{id:"ISORGANIZATION", value: 'ISSUER_OF_INVOICE', label: 'Emetteur de la facture (Facturé par)'},
{id:"ISORGANIZATION", value: 'STORAGE_AND_HANDLING', label: 'Stockage et manipulation'},
{id:"ISORGANIZATION", value: 'CONSIGNOR', label: 'Expéditeur (Livré par)'},
{id:"ISORGANIZATION", value: 'FARM_OPERATOR', label: 'Exploitant agricole'},
{id:"ISORGANIZATION", value: 'EXPORTER', label: 'Exportateur'},
{id:"ISORGANIZATION", value: 'MANUFACTURER_OF_GOODS', label: 'Fabricant de marchandises'},
{id:"ISORGANIZATION", value: 'SUPPLIER', label: 'Fournisseur'},
{id:"ISORGANIZATION", value: 'SERVICE_PROVIDER', label: 'Fournisseur de services'},
{id:"ISORGANIZATION", value: 'HEALTHCARE_PROVIDER', label: 'Fournisseur de soins de santé'},
{id:"ISORGANIZATION", value: 'WHOLESALER', label: 'Grossiste'},
{id:"ISORGANIZATION", value: 'IMPORTER', label: 'Importateur'},
{id:"ISORGANIZATION", value: 'ORDERING_PARTY', label: 'Organisme de commande'},
{id:"ISORGANIZATION", value: 'DELIVERY_PARTY', label: 'Organisme de réception (Livré à)'},
{id:"ISORGANIZATION", value: 'CHECKING_PARTY', label: 'Organisme de vérification'},
{id:"ISORGANIZATION", value: 'DESPATCH_PARTY', label: 'Organisme d\'expédition'},
{id:"ISORGANIZATION", value: 'INVOICEE', label: 'Parti facturé (Facturé à)'},
{id:"ISORGANIZATION", value: 'LOGISTICS_SERVICE_PROVIDER', label: 'Prestataire de services logistiques'},
{id:"ISORGANIZATION", value: 'BRAND_OWNER', label: 'Propriétaire de la marque'},
// {id:"ISORGANIZATION", value: 'EQUIPMENT_OWNER', label: 'Propriétaire de l\'équipement'},
// {id:"ISORGANIZATION", value: 'GOODS_OWNER', label: 'Propriétaire de marchandises'},
// {id:"ISORGANIZATION", value: 'OWNER_OF_MEANS_OF_TRANSPORT', label: 'Propriétaire du moyen de transport'},
{id:"ISORGANIZATION", value: 'PURCHASE_ORDER_RECEIVER', label: 'Récepteur du bon de commande'},

{id:"ISORGANIZATION", value: 'CARRIER', label: 'Transporteur'},
{id:"ISORGANIZATION", value: 'SELLER', label: 'Vendeur (Commandé à)'},
{id:"ISLocation", value: 'OFFICE', label: 'Bureau'},
{id:"ISLocation", value: 'DISTRIBUTION_CENTRE', label: 'Centre de distribution'},
{id:"ISLocation", value: 'WAREHOUSE_AND_OR_DEPOT', label: 'Entrepôt'},
{id:"ISLocation", value: 'SHIPPING_AREA', label: 'Lieu de collecte'},
{id:"ISLocation", value: 'RECEIVING_LOCATION', label: 'Lieu de réception'},
{id:"ISLocation", value: 'STORE', label: 'Magasin'},
{id:"ISLocation", value: 'POINT_OF_SALE', label: 'Point de vente'},
{id:"ISLocation", value: 'EDI_STATION', label: 'Station EDI'}


// {value: 'SLAUGHTERER', label: 'Abatteur (Boucherie/Charcuterie)'},
// {value: 'BROKER_AGENT', label: 'Agent de courtage'},
// {value: 'REGISTERED_AGENT', label: 'Agent enregistré'},
// {value: 'INSURER', label: 'Assureur'},
// {value: 'RECALL_SPONSOR', label: 'Commanditaire du rappel'},
// {value: 'CONSOLIDATOR', label: 'Consolidateur'},
// {value: 'INVENTORY_CONTROLLER', label: 'Contrôleur d\'inventaire'},
// {value: 'CUTTER', label: 'Coupeur (Boucherie/Charcuterie)'},
// {value: 'CUSTOMS_BROKER', label: 'Courtier en douane'},
// {value: 'DESIGNER', label: 'Designer'},
// {value: 'RECALL_RECIPIENT', label: 'Destinataire du rappel'},
// {value: 'FOODSERVICE_DISTRIBUTOR', label: 'Distributeur de services alimentaires'},
// {value: 'OPERATING_DIVISION', label: 'Division opérationnelle'},
// {value: 'BREEDER', label: 'Éleveur'},
// {value: 'PACKER', label: 'Emballeur'},
// {value: 'FATTENER', label: 'Engraisseur'},
// {value: 'WAREHOUSE_KEEPER', label: 'Entrepositaire'},
// {value: 'PROXY', label: 'Entreprise de procuration'},
// {value: 'PHARMACY_OPERATOR', label: 'Exploitant de pharmacie'},
// {value: 'FOODSERVICE_OPERATOR', label: 'Exploitant de services alimentaires'},
// {value: 'FACTOR', label: 'Factor'},
// {value: 'SUBSTITUTE_SUPPLIER', label: 'Fournisseur suppléant'},
// {value: 'MINCER', label: 'Hachoir'},
// {value: 'CORPORATE_IDENTITY', label: 'Identité d\'entreprise'},
// {value: 'HARVESTER', label: 'Moissonneur'},
// {value: 'OPERATOR', label: 'Opérateur'},
// {value: 'MARKETPLACE_OPERATOR', label: 'Opérateur de marché'},
// {value: 'FISHING_OPERATOR', label: 'Opérateur de pêche'},
// {value: 'TRANSPORTATION_CARRIER', label: 'Organisateur de Transport'},
// {value: 'INVENTORY_REPORTING_PARTY', label: 'Organisation chargée de présenter des rapports sur les stocks'},
// {value: 'EMPTY_EQUIPMENT_RETURN_PARTY'  , label: 'Organisation de retour d\'équipement vide'},
// {value: 'PRICE_LOCATION_PARTY', label: 'Organisation d\'emplacement des prix'},
// {value: 'EMPTY_EQUIPMENT_DESPATCH_PARTY', label: 'Organisation d\'expédition d\'équipement vide'},
// {value: 'GROWER', label: 'Producteur'},
// {value: 'CLINICAL_TRIAL_SPONSOR', label: 'Promoteur de l’essai clinique'},
// {value: 'OWNER_OF_EQUIPMENT', label: 'Propriétaire de l\'équipement'},
// {value: 'BUYERS_AGENT_REPRESENTATIVE', label: 'Représentant de l\'acheteur'},
// {value: 'DECLARANTS_AGENT_REPRESENTATIVE', label: 'Représentant de l\'agent déclarant'},
// {value: 'CENTRAL_PAYMENT_SERVICE', label: 'Service central de paiement'},
// {value: 'CASH_TRANSPORT_SERVICES', label: 'Service de transport de fonds'},
// {value: 'TRADER', label: 'Trader'},
// {value: 'FREIGHT_FORWARDER', label: 'Transitaire'}
]
